import { useRef } from 'react';
import { useApolloClient, ApolloLink, from, Observable } from '@apollo/client';
import { useDataFetchingClient } from 'data-fetching-client';
import { captureException, createBoardError, shouldTrackApolloError } from '../error/utils';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const TrackErrorQueryProvider = ({
  children
}) => {
  const client = useApolloClient();
  const dfcClient = useDataFetchingClient();
  const dfcLink = useRef(null);
  const apLink = useRef(null);
  //only do this once
  if (dfcLink.current && apLink.current) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  const errorTrackingLink = new ApolloLink((operation, forward) => {
    return new Observable(observer => {
      const observable = forward(operation);
      const subscription = observable.subscribe({
        next(value) {
          if (value !== null && value !== void 0 && value.errors) {
            if (shouldTrackApolloError(operation.operationName)) {
              value.errors.forEach(error => {
                const boardError = createBoardError(`${operation.operationName}${error.message ? `:${error.message}` : ''}`);
                captureException(boardError, error);
              });
            }
          }
          observer.next(value);
        },
        error(networkError) {
          if (shouldTrackApolloError(operation.operationName)) {
            const boardError = createBoardError(`${operation.operationName}${networkError.status ? `:${networkError.status}` : ''}${networkError.message ? `:${networkError.message}` : ''}`);
            captureException(boardError, networkError, {
              fingerprint: [operation.operationName, networkError.status || '0'],
              extra: {
                variables: JSON.stringify(operation.variables)
              }
            });
          }
          observer.error(networkError);
        },
        complete() {
          observer.complete();
        }
      });
      return () => subscription.unsubscribe();
    });
  });
  apLink.current = from([errorTrackingLink, client.link]);
  client.setLink(apLink.current);
  dfcLink.current = from([errorTrackingLink, dfcClient.link]);
  dfcClient.setLink(dfcLink.current);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};